import { Button } from '@coolblue-development/freddy';
import { Edit } from '@coolblue-development/icons';
import { useRef, useEffect, useState } from 'react';
import { EmailClient } from '@amazon-connect/email';
import { datadogLogs } from '@datadog/browser-logs';
import { useEmailContext } from '../../../../../contexts/EmailContext';

const CreateOutboundEmailButton = (): JSX.Element => {
  const { setSelectedEmail, setOutboundContactId, setIsReplyOpen, outboundContactId } = useEmailContext();
  const emailClientRef = useRef<EmailClient | null>(null);
  const [isCreating, setIsCreating] = useState(false);

  useEffect(() => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
      emailClientRef.current = new EmailClient(connect.core.getSDKClientConfig() as any);
    } catch (error) {
      datadogLogs.logger.error('Failed to initialize EmailClient', { channel: 'email' }, error as Error);
    }
  }, []);

  const handleWriteNewEmail = async (): Promise<void> => {
    if (!emailClientRef.current || isCreating) return;

    setIsCreating(true);
    try {
      const { contactId } = await emailClientRef.current.createDraftEmail({
        initiationMethod: 'OUTBOUND'
      });
      setSelectedEmail(contactId);
      setOutboundContactId(contactId);
      setIsReplyOpen(true);
    } catch (error) {
      datadogLogs.logger.error('Failed to create outbound email', { channel: 'email' }, error as Error);
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <Button
      startIcon={<Edit />}
      fullWidth
      size="small"
      sx={{ marginBottom: '8px' }}
      onClick={() => void handleWriteNewEmail()}
      disabled={isCreating || outboundContactId !== null}
    >
      Write new email
    </Button>
  );
};

export default CreateOutboundEmailButton;
